var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 8 8",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.53001 6.90504L7.85732 2.0341C8.20036 1.53191 7.88605 0.800195 7.3273 0.800195L0.6727 0.800195C0.113949 0.800195 -0.200356 1.53191 0.142684 2.0341L3.46999 6.90504C3.73881 7.29858 4.26119 7.29858 4.53001 6.90504Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescendingIcon);
export default __webpack_public_path__ + "static/media/DescendingIcon.5ced1a0312f4cd7046fdc62131efe21d.svg";
export { ForwardRef as ReactComponent };